/**
 * @Author : zhouqinze
 * @Date : 2019-12-30
 * @Version : 1.0
 * @Content : 首页头部
 **/
<template>
    <div>
        <div class="header" :style="{boxShadow:newsIF?'0 0 10px #ccc':''}">
            <div class="header-content">
                <h1>通易科技</h1>
                <!-- <img src="http://comit.oss-cn-hangzhou.aliyuncs.com/img/img_logo.png" title="通易科技" alt="通易科技"> -->
                <img src="../assets/img/img_logo.png" title="通易科技" alt="通易科技">
                <ul class="headerTab">
                    <li v-for="(item,index) in headerArr" :key="index" @mouseenter="lowShow(index)" @click="goto(index)" :style="{borderBottom:tabOneArr[index]?'3px solid #018CF4':'3px solid #fff'}">{{item}}</li>
                </ul>
            </div>
        </div>
        <div class="header-low" :style="{height:showHeight}" @mouseleave="lowOff()">
            <div class="header-low-content">
                <ul class="low-box" >
                    <li v-for="(item,index) in lowBoxArr" :key ="index" @click="gotoSec(index)">{{item}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data:function(){
        return {
            tabOneArr:[true,false,false,false],
            showHeight:"0",
            headerArr:['首页','旗下项目','关于通易','企业文化'],
            routerID:['/home','/comobject','/comabout','/comculture'],
            aboutObject:['数字交通','优驾数字坐舱','企业数字转型'],
            aboutComit:['通易简介','资质荣誉','合作伙伴','联系我们'],
            comitShow:['员工关怀','员工活动','职业发展','加入我们'],
            routerArr:[[],['/comobject/traffic','/comobject/youjia','/comobject/change'],['/comabout/synopsis','/comabout/honor','/comabout/partner','/comabout/connection'],['/comculture/care','/comculture/activity','/comculture/grow','/comculture/joinus']],
            tabIndex:0,
            // newsIf:true
        }
    },
    methods:{
        lowShow:function(i){
            for(let index in this.tabOneArr){
                if(i == index){
                    this.tabOneArr[index] = true
                }else{
                    this.tabOneArr[index] = false
                }
            }
            this.tabIndex = i
            if(this.tabIndex > 0){
                this.showHeight = '62px'
            }else{
                this.showHeight = '0'
            }
        },
        lowOff:function(){
            this.showHeight = '0'
        },
        goto(index){
            window.sessionStorage.setItem('sendIndex',0)
            this.$router.push(this.routerID[index])
        },
        gotoSec(index){
            window.sessionStorage.setItem('sendIndex',index)
            this.$router.push(this.routerArr[this.tabIndex][index])
        }
    },
    computed: {
        lowBoxArr:function(){
            if(this.tabIndex == 1){
                return ['数字交通','优驾数字坐舱','企业数字转型']
            }
            if(this.tabIndex == 2){
                return ['通易简介','资质荣誉','合作伙伴','联系我们']
            }
            if(this.tabIndex == 3){
                return ['员工关怀','员工活动','职业发展','加入我们']
            }
            else{
                return []
            }
        },
        newsIF:function(){
            window.console.log(this.$route.path)
            let isTurn = false
            if(this.$route.path == '/news'){
                isTurn = true
            }else{
                isTurn = false
            }
            window.console.log(isTurn)
            return isTurn
        }
    },
}
</script>
<style lang="scss" scoped>
    .header{
        font-size: .9375rem;
        height:4.9375rem;
        line-height:4.9375rem;
        width:100%;
        background:#fff;
        box-sizing: border-box;
        z-index: 9999;
        position: relative;
        // margin-bottom: 3px;
        .header-content{
            max-width:75rem;
            height: 100%;
            margin: auto;
            position: relative;
            h1{
                text-indent:-9999px;
                position: absolute;
            }
            img{
                display: block;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 10.1875rem;
                height: 3.125rem;
            }
            .headerTab{
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                display: flex;
                height: 100%;
                box-sizing: border-box;
                padding-bottom: 3px;
                li{
                    width: 5.5rem;
                    text-align: center;
                    border-bottom: .1875rem solid #fff;
                    box-sizing: border-box;
                    cursor: pointer;
                }
                li:hover{
                    color: #018CF4;
                    transition: border-bottom 1s;
                    // border-bottom: 3px solid #018CF4;
                }
            }
        }
    }
    .header-low{
        width: 100%;
        font-size: .9375rem;
        height:3.875rem;
        line-height:3.875rem;
        background: #F4F4F4; 
        transition: height 1s;
        box-sizing: border-box;
        overflow: hidden;
        .header-low-content{
            width: 75rem;
            margin: auto;
            box-sizing: border-box;
            .low-box{
                display: flex;
                justify-content: flex-end;
                li{
                    padding: 0 1.25rem;
                    cursor: pointer;
                }
                li:hover{
                        color: #018CF4;
                }
            }
        }
    }
</style>